export default __webpack_public_path__ + "../staticImages/hawesko-select-logo.jpg";